import { useCallback, useEffect, useState } from 'react';
import cls from 'classnames';
import Request from '@/utils/Request';
import Header from '@/components/h5/sciex/Header';
import Menu from '@/components/h5/sciex/Menu';
import Nav from '@/components/h5/sciex/Nav';
import Hots from '@/components/h5/sciex/Hots';
import Activity from '@/components/h5/sciex/Activity';
import Production from '@/components/h5/sciex/Production';
import styles from './index.module.scss';

export default () => {
  const [dataSource, setDataSource] = useState<Record<string, any>>({});
  const loadData = useCallback(async () => {
    const res = await Request.post(`/sciex`, {});
    console.log('res====', res);
    if (res.errno === 0) {
      setDataSource(res.data);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);
  return (
    <div className={styles['sciex-index']}>
      <Header />
      <Menu />
      <Nav navs={dataSource.goodsCategory} />
      <Activity slideshow={dataSource.slideshow} />
      <Hots hotGoods={dataSource.hotGoods} />
      <Production list={dataSource.floors} />
    </div>
  );
};
